import { AfterViewInit, Component, Input, OnChanges, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { IonicModule, LoadingController } from '@ionic/angular';
import { ToastController } from '@ionic/angular';
import { Analysis, BeerProfileRequest, BeerStat, SearchCharacteristicWithType, SearchType, AnalysisItem, LocalCharacteristic, Venue, SimilarBeerRequest, BaseFlavors} from "../../models/models";
import { AnalysisServiceProvider } from '../../providers/analysis-service/analysis-service';
import { LocationServiceProvider } from "../../providers/location-service/location-service";
import { UserDataProvider } from '../../providers/user-data/user-data';
import { BeerServiceProvider } from '../../providers/beer-service/beer-service';
import { BhutilProvider } from '../../providers/bhutil/bhutil';
import { AnalysisHolderProvider } from '../../providers/analysis-holder/analysis-holder';
import { RefdataProvider } from '../../providers/refdata/refdata';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Storage } from '@ionic/storage-angular';
import { AppEventService } from '../../app/app-events';
import { SimilarBeersComponent } from '../similar-beers/similar-beers';
import { BeerSpiderComponent } from '../beer-spider/beer-spider';
import { BeerCcComponent } from '../beer-cc/beer-cc';
import { FlavorSliderAnalysisComponent } from '../flavor-slider/flavor-slider-analysis';
import { BeerHiveComponent } from '../beer-hive/beer-hive';
import { BeerIbaComponent } from '../beer-iba/beer-iba';
import { BeerAromasComponent } from '../beer-aromas/beer-aromas';
import { RatingBarComponent } from '../rating-bar/rating-bar';
import { WishlistButtonComponent } from '../wishlist-button/wishlist-button';
import { CommonModule } from '@angular/common';
import { MyNotesComponent } from '../my-notes/my-notes';
import { FormsModule } from '@angular/forms';
import { BeerAnalysisMyComponent } from './beer-analysis-my';

/**
 * Generated class for the BeerAnalysisMyComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'beer-analysis-my-flavor',
  templateUrl: 'beer-analysis-my-flavor.html',
  styleUrls: ['./beer-analysis-my.scss'],
  standalone: false,
  imports: [
    IonicModule,
    TranslateModule,
    SimilarBeersComponent,
    BeerSpiderComponent,
    BeerCcComponent,
    FlavorSliderAnalysisComponent,
    BeerHiveComponent,
    BeerIbaComponent,
    BeerAromasComponent,
    RatingBarComponent,
    WishlistButtonComponent,
    CommonModule,
    FormsModule,
    MyNotesComponent
  ]
})

export class BeerAnalysisMyFlavorComponent extends BeerAnalysisMyComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {

  /*
   *  attributes to manage the gui appearance
   */
  shouldIgnoreSliderUpdate: boolean;

  /*
   *  transport objects to convey data from and to the gui
   */
  currentBaseFlavors: BaseFlavors = {
    sweet: 0,
    sour: 0,
    bitter: 0,
    fruity: 0,
    hoppy: 0,
    malty: 0,
    color: 0,
    clarity: 0
  };

  /*
   *  the model: beerID and analysis objects
   */
  theBeerID: string;

  private showBeerSubscription: any;
  private analyseColourInputSubscription: any;

  constructor(
    protected toastController: ToastController,
    protected events: AppEventService,
    protected analysisService: AnalysisServiceProvider,
    private locationService: LocationServiceProvider,
    private userData: UserDataProvider,
    private beerService: BeerServiceProvider,
    protected bhutil: BhutilProvider,
    private loadingCtrl: LoadingController,
    protected beerAnalysisHolder: AnalysisHolderProvider,
    private refdata: RefdataProvider,
    protected translateService: TranslateService,
    private storage: Storage
  ) {
    super(toastController, events, analysisService, bhutil, beerAnalysisHolder, translateService);

    this.shouldIgnoreSliderUpdate = false;

    //default slider values
    this.currentBaseFlavors.sweet = -1;
    this.currentBaseFlavors.sour = -1;
    this.currentBaseFlavors.bitter = -1;
    this.currentBaseFlavors.hoppy = -1;
    this.currentBaseFlavors.fruity = -1;
    this.currentBaseFlavors.malty = -1;

    this.currentBaseFlavors.color = -1;
    this.currentBaseFlavors.clarity = 1;

    this.showBeerSubscription = () => {
      console.log("[beer-analysis-my-flavor.showBeerSubscription] called");
      this.clearTransferObjectsAndModel();

      // 2 Fill the model
      // 2A if the beer profile is not yet loaded, load the beer profile
      // 2B if the beer profile is already loaded, switch the analysisHolder to the beer
      if (this.beerAnalysisHolder.hasActiveBeer()) {
        this.updateBeerID(this.beerAnalysisHolder.getActiveBeer());

        if (this.beerAnalysisHolder.hasBeer(this.theBeerID)) {
          console.log("BeerAnalysisMyFlavorComponent.showBeerSubscription: switch to beer " + this.theBeerID);
          this.beerAnalysisHolder.switchToBeer(this.theBeerID);

          // 3 Update the GUI elements, fill the transfer objects and publish the updates to the GUI
          this.updateView();
        }
        else {
          console.log("BeeranalysisMyFlavorComponent.showBeerSubscription: no beer profile");
        }
      }
      else {
          console.log("BeeranalysisMyFlavorComponent.showBeerSubscription: no active beer");
      }
    };

    this.analyseColourInputSubscription = (colourCharacteristic: SearchCharacteristicWithType) => {

      this.currentBaseFlavors.color = colourCharacteristic.characteristic.value.valueOf();
      this.beerAnalysisHolder.getMyAnalysis().colour = colourCharacteristic.characteristic.value;
      this.beerAnalysisHolder.checkForDifferences();
    };
  }
  private clearTransferObjectsAndModel() {
    // 1 Make the context clean:
    //   - empty the model: deactivate the previous beer profile from the analysis holder
    //   - empty the transfer objects and the view
    // 2 Fill the model
    // 2A if the beer profile is not yet loaded, load the beer profile
    // 2B if the beer profile is already loaded, switch the analysisHolder to the beer
    //
    // 3 Fill the transfer objects and publish the updates to the GUI
    // 1 Make the context clean:

    //   - empty the transfer objects and the view
    //spider values
    console.log("clearspidervalues 1");
    this.clearSpiderValuesTransferObjectandPublishEvent();

    this.beerAnalysisHolder.shouldCheck = true;
  }

  ngAfterViewInit() {
    console.log("[beer-analysis-my-flavor] ngAfterViewInit called");
    if (this.beerAnalysisHolder.hasActiveBeer()) {
      this.showCurrentAnalysis(false);
    }

    /*this.storage.get('selected-venue').then((venue) => {
      // First read the selected venue from storage
      let venueJSON = JSON.parse(venue);
      if (venueJSON != null) {
        this.selectedVenue = venueJSON;
        console.log("[my-analyses] - currently venue with id selected: " + venueJSON.id);
      }
    });*/
  }

  // show current analysis instance
  showCurrentAnalysis(shouldShowToast: boolean) {
    console.log("[beer-analysis-my.showCurrentAnalysis] called with shouldShowToast = " + shouldShowToast);

    let currentAnalysis: Analysis = this.beerAnalysisHolder.getMyAnalysis();
    // this.tweakAnalysisBeforeViewing(currentAnalysis);

    // Step 1: populate transfer objects

    // Step 1A - currentBaseFlavors
    this.updateColourFromAnalysis(currentAnalysis);
    this.updateSliderGUIFromAnalysis(currentAnalysis, true /* why false ? */);
    this.updateSpiderValuesFromAnalysis(currentAnalysis);

    let currentAnalysisId = currentAnalysis.id;
    if (currentAnalysisId != undefined)
      this.analysisService.setAnalysisId(currentAnalysisId);
  }

  updateBeerID(bID: string) {
    console.log("updateBeerID() => " + bID);
    //debugger;
    this.theBeerID = bID;
    this.analysisService.setBeerId(bID);
  }

  ngOnInit() {
    console.log("[beer-analysis-my-flavor] [ngOnInit] called");
    // setting last caller page
    this.events.subscribe("beer-analysis:show:beer-analysis-my", this.showBeerSubscription);
    this.events.subscribe("analyse:colourInput", this.analyseColourInputSubscription);

    this.analysisService.setLastPage("analysis");

    if (this.beerAnalysisHolder.hasActiveBeer()) {
      this.showCurrentAnalysis(false);
//      this.updateSpiderValuesFromAnalysis(this.beerAnalysisHolder.getMyAnalysis());
    }
  }
  ngOnChanges() {
    console.log("[beer-analysis-my-flavor] [ngOnChanges] called");
  }

  ngOnDestroy() {

    console.log("[beer-analysis-my-flavor] [ngOnDestroy] DESTROYING for beer ID " + this.theBeerID);
    this.events.unsubscribe("beer-analysis:show:beer-analysis-my");
    this.events.unsubscribe("similar-beers:show:beer-analysis", this.showBeerSubscription);
    this.events.unsubscribe("analyse:colourInput", this.analyseColourInputSubscription);
  }

  public updateView() {
    console.log("[beer-analysis-my-flavor] updateView() called");
    this.showCurrentAnalysis(false);
  }

  handleBaseFlavorsUpdateFromGUI(newBaseFlavors: BaseFlavors) {
    console.log("[beer-analysis-my-flavor] handleBaseFlavorsUpdateFromGUI() called");

    // Guard against updates if nothing changed
    // If the "new" value is exactly the same as the current Input value
    // (e.g. because the Input set the slider, and the slider fired back), STOP.
    if (JSON.stringify(newBaseFlavors) === JSON.stringify(this.currentBaseFlavors)) {
      return;
    }    
    console.log("[beer-analysis-my-flavor] handleBaseFlavorsUpdateFromGUI(): now it is value " + JSON.stringify(newBaseFlavors, null, 2));

    // update the transfer object
    this.currentBaseFlavors = newBaseFlavors;

    // update the model
    this.beerAnalysisHolder.getMyAnalysis().sweet = this.currentBaseFlavors.sweet;
    this.beerAnalysisHolder.getMyAnalysis().sour = this.currentBaseFlavors.sour;
    this.beerAnalysisHolder.getMyAnalysis().bitter = this.currentBaseFlavors.bitter;
    this.beerAnalysisHolder.getMyAnalysis().hoppy = this.currentBaseFlavors.hoppy;
    this.beerAnalysisHolder.getMyAnalysis().fruity = this.currentBaseFlavors.fruity;
    this.beerAnalysisHolder.getMyAnalysis().malty = this.currentBaseFlavors.malty;

    this.beerAnalysisHolder.checkForDifferences();
  }

  updateColourFromAnalysis(currentAnalysis) {
    console.log("[beer-analysis-my-flavor] PUB set:colour");
    let currentColour = currentAnalysis.colour;

    //added this one
    this.currentBaseFlavors.color = currentColour;

    this.events.publish("set:colour", currentColour);
  }

  updateSliderGUIFromAnalysis(currentAnalysis: any, shouldUpdate: boolean) {
    console.log("[beer-analysis-my-flavor] - updateFlavorSlidersFromAnalysis() shouldUpdate: " + shouldUpdate);
    console.dir(currentAnalysis);
    //debugger;
    this.currentBaseFlavors.sweet = -1;
    if (currentAnalysis.sweet !== undefined)
      this.currentBaseFlavors.sweet = this.getRounded(currentAnalysis.sweet);

    this.currentBaseFlavors.sour = -1;
    if (currentAnalysis.sour !== undefined)
      this.currentBaseFlavors.sour = this.getRounded(currentAnalysis.sour);

    this.currentBaseFlavors.bitter = -1;
    if (currentAnalysis.bitter !== undefined)
      this.currentBaseFlavors.bitter = this.getRounded(currentAnalysis.bitter);

    this.currentBaseFlavors.hoppy = -1;
    if (currentAnalysis.hoppy !== undefined)
      this.currentBaseFlavors.hoppy = this.getRounded(currentAnalysis.hoppy);

    this.currentBaseFlavors.fruity = -1;
    if (currentAnalysis.fruity !== undefined)
      this.currentBaseFlavors.fruity = this.getRounded(currentAnalysis.fruity);

    this.currentBaseFlavors.malty = -1;
    if (currentAnalysis.malty !== undefined)
      this.currentBaseFlavors.malty = this.getRounded(currentAnalysis.malty);

    let sliderValues = {
      "sweet": this.getRounded(this.currentBaseFlavors.sweet),
      "sour": this.getRounded(this.currentBaseFlavors.sour),
      "bitter": this.getRounded(this.currentBaseFlavors.bitter),
      "hoppy": this.getRounded(this.currentBaseFlavors.hoppy),
      "fruity": this.getRounded(this.currentBaseFlavors.fruity),
      "malty": this.getRounded(this.currentBaseFlavors.malty),
      "update": shouldUpdate
    }

    this.shouldIgnoreSliderUpdate = true;
    console.log("PUB update:sliders fromAnalysis, shouldUpdate: " + shouldUpdate);
    this.events.publish("update:sliders", sliderValues);
  }

  updateCC(ccInfo: any) {
    console.log("[beer-analysis-my-flavor] updateCC: color: " + ccInfo.color + " / clarity: " + ccInfo.clarity);

    this.currentBaseFlavors.color = ccInfo.color;
    this.currentBaseFlavors.clarity = ccInfo.clarity;
    //change a local value, that is coupled to the beer-hive
    this.triggerSpiderUpdateFromBaseFlavors();
  }

  triggerSpiderUpdateFromBaseFlavors() {
    let hiveEvent = {
      "sweet": this.currentBaseFlavors.sweet,
      "sour": this.currentBaseFlavors.sour,
      "bitter": this.currentBaseFlavors.bitter,
      "hoppy": this.currentBaseFlavors.hoppy,
      "fruity": this.currentBaseFlavors.fruity,
      "malty": this.currentBaseFlavors.malty,
      "color": this.currentBaseFlavors.color,
      "clarity": this.currentBaseFlavors.clarity
    };
    this.events.publish("update:spider", hiveEvent);
  }
  updateSpiderValuesFromAnalysis(currentAnalysis) {
    //debugger;
    // publish an event, check if values are present
    let sweetValue = currentAnalysis.sweet !== undefined ? this.getRounded(currentAnalysis.sweet) : 0;
    let sourValue = currentAnalysis.sour !== undefined ? this.getRounded(currentAnalysis.sour) : 0;
    let bitterValue = currentAnalysis.bitter !== undefined ? this.getRounded(currentAnalysis.bitter) : 0;
    let hoppyValue = currentAnalysis.hoppy !== undefined ? this.getRounded(currentAnalysis.hoppy) : 0;
    let fruityValue = currentAnalysis.fruity !== undefined ? this.getRounded(currentAnalysis.fruity) : 0;
    let maltyValue = currentAnalysis.malty !== undefined ? this.getRounded(currentAnalysis.malty) : 0;
    let colorValue = currentAnalysis.colour !== undefined ? this.getRounded(currentAnalysis.colour) : 0;

    this.currentBaseFlavors.sweet = sweetValue;
    this.currentBaseFlavors.sour = sourValue;
    this.currentBaseFlavors.bitter = bitterValue;
    this.currentBaseFlavors.hoppy = hoppyValue;
    this.currentBaseFlavors.fruity = fruityValue;
    this.currentBaseFlavors.malty = maltyValue;
    this.currentBaseFlavors.color = colorValue;
    this.currentBaseFlavors.clarity = -1;

    this.triggerSpiderUpdateFromBaseFlavors();
  }

  clearSpiderValuesTransferObjectandPublishEvent() {

    //debugger;

    //publish an event
    // this was 0; changed it to -1 for bug BEERHIVE-98
    let sweetValue = -1;
    let sourValue = -1;
    let bitterValue = -1;
    let hoppyValue = -1;
    let fruityValue = -1;
    let maltyValue = -1;
    let colorValue = -1; // this.currentBaseFlavors.color;// no color, invalid color

    this.currentBaseFlavors.sweet = sweetValue;
    this.currentBaseFlavors.sour = sourValue;
    this.currentBaseFlavors.bitter = bitterValue;
    this.currentBaseFlavors.hoppy = hoppyValue;
    this.currentBaseFlavors.fruity = fruityValue;
    this.currentBaseFlavors.malty = maltyValue;
    this.currentBaseFlavors.color = colorValue;
    this.currentBaseFlavors.clarity = -1;

    this.triggerSpiderUpdateFromBaseFlavors();
  }
}
